import { orchestrator } from 'satcheljs';
import { applyOptions } from '../actions/activityFeedApplyOptions';
import {
    loadMentionEventNotificationsOptions,
    loadTxpEventNotificationsOptions,
} from '../service/loadActivityFeedOptions';
import {
    createOrUpdateMentionEventNotificationsOptions,
    createOrUpdateTxpEventNotificationsOptions,
} from '../service/saveActivityFeedOptions';
import { getActivityFeedSettingsStore } from '../store/notificationSettingStore';
import { ActivityFeedSettingIds } from '../service/ActivityFeedSettingType';

async function toggleMentionsProcessor() {
    const userOptions = await loadMentionEventNotificationsOptions();
    const isSettingsEnabled = getActivityFeedSettingsStore().get(
        ActivityFeedSettingIds.emailMentionNotification
    );
    if (isSettingsEnabled != userOptions.enabled) {
        userOptions.enabled = isSettingsEnabled;
        createOrUpdateMentionEventNotificationsOptions(userOptions);
    }
}

async function toggleTxpProcessor() {
    const userOptions = await loadTxpEventNotificationsOptions();
    const isSettingsEnabled = getActivityFeedSettingsStore().get(
        ActivityFeedSettingIds.flightNotification
    );
    if (isSettingsEnabled != userOptions.enabled) {
        userOptions.enabled = isSettingsEnabled;
        createOrUpdateTxpEventNotificationsOptions(userOptions);
    }
}

// Refreshing the app or closing/opening the panel toggles the options
// server side based on related feature flags.
orchestrator(applyOptions, () => {
    toggleMentionsProcessor();
    toggleTxpProcessor();
});
